import { useClientPortalConfigContext } from "../../../context";
import { useEffect } from "react";
import { useAnalytics } from "hooks/useAnalytics";
import { StripeProvider, useInitializeStripe } from "../../Shared/Stripe";
import { InvoiceItemModel } from "types/generated/models";
import LoadingOverlay from "../../Shared/LoadingOverlay";
import { SimpleDialog } from "@powerdiary/components-library/lib";
import InvoiceViewStripePayment from "../InvoiceViewStripePayment";

interface IInvoiceViewStripePayDialog {
    invoice: InvoiceItemModel;
    handleClose: () => void;
}

export default function InvoiceViewStripePayDialog({ invoice, handleClose }: IInvoiceViewStripePayDialog) {
    const { clientPortalConfig } = useClientPortalConfigContext();
    const { track } = useAnalytics();
    const { stripe, loading: stripeLoading } = useInitializeStripe({
        stripeKey: clientPortalConfig.stripeKey,
        practitionerStripeAccountId: invoice.practitioner?.stripeAccount,
    });
    useEffect(() => {
        track("invoice_view_payment_form_opened", {
            invoice_count: 1,
            amount: invoice.totalAmount,
        });
    }, [track, invoice]);

    if (stripeLoading) {
        return <LoadingOverlay />;
    }

    return (
        <SimpleDialog
            open
            handleClose={handleClose}
            dialogTitleText="Credit card payment"
            dataTestIdSuffix="stripe_invoice_pay"
            renderContent={() => (
                <StripeProvider stripe={stripe}>
                    <InvoiceViewStripePayment invoice={invoice} handleClose={handleClose} />
                </StripeProvider>
            )}
        ></SimpleDialog>
    );
}
